import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  ModuleSelectionControllerService,
  ModuleSelectionDTO,
} from '@soctrip/angular-marketing-hub-service';
import { Subject, debounceTime } from 'rxjs';
import { Province } from 'src/app/core/models/interfaces/address';
import { BlockEntityData } from 'src/app/core/models/interfaces/marketing-builder';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-shops-modal',
  templateUrl: './add-shops-modal.component.html',
  styleUrls: ['./add-shops-modal.component.scss'],
})
export class AddShopsModalComponent implements OnInit {
  @Input({ required: true }) isModal = false;
  @Input() selectedShops: BlockEntityData[] = [];
  @Input() filter: ModuleSelectionDTO;
  @Input() cities: Province[] = [];
  @Input() moduleDataId: string = '';

  @Output() isModalChange = new EventEmitter<boolean>();
  @Output() selectedShopsChange = new EventEmitter<BlockEntityData[]>();

  isLoading: boolean = false;
  isFetched: boolean = false;
  RATINGS = [1, 2, 3, 4, 5];
  COLS_QUANTITY_LOADING = Array(5).fill(1);
  ROWS_QUANTITY_LOADING = Array(5).fill(5);
  pagination = {
    rows: 10,
    page: 0,
  };
  shops = [];
  _totalElement: number;
  keyword = '';
  keywordChanged = new Subject<string>();
  rating: number | null = null;
  location: string = '';

  constructor(
    private http: HttpClient,
    private moduleSelectionService: ModuleSelectionControllerService,
  ) {}

  ngOnInit(): void {
    this.keywordChanged.pipe(debounceTime(600)).subscribe({
      next: (keyword) => {
        this.keyword = keyword;
        this.resetPaginator();
        this._initShops();
      },
    });
    this._initShops();
  }

  resetPaginator() {
    this.pagination = {
      rows: 10,
      page: 0,
    };
  }

  _initShops() {
    this.isLoading = true;
    const searchFilter = this.keyword ? `name@=${this.keyword}` : '';
    const ratingFilter = this.rating ? `rating>=${this.rating}` : '';
    const locationFilter = this.location
      ? `shop_address.province.id==${this.location}`
      : '';

    const filters = [searchFilter, ratingFilter, locationFilter]
      .filter((item) => !!item)
      .join(',');

    this.http
      .get(
        `${environment.BE_URL}marketing-hub/module-selections/${
          this.moduleDataId
        }/data?filters=${encodeURIComponent(filters)}&pageNum=${
          this.pagination.page
        }&pageSize=${this.pagination.rows}`,
      )

      .subscribe({
        next: (res: any) => {
          const data = res?.data;

          if (data?.length > 0) {
            this.shops = data;
          } else if (data?.data?.length > 0) {
            this.shops = data.data;
            this._totalElement = data.totalElement;
          } else {
            this.shops = data.data?.data;
            this._totalElement = data?.data.totalElement;
          }
        },
        error: () => {
          this.isLoading = false;
        },
        complete: () => {
          this.isFetched = true;
          this.isLoading = false;
        },
      });
  }

  setIsModal(isModal: boolean) {
    this.isModal = isModal;
    this.isModalChange.emit(this.isModal);
  }

  onCancelAddShop() {
    this.setIsModal(false);
  }

  onAddShops() {
    this.selectedShopsChange.emit(this.selectedShops);
    this.setIsModal(false);
  }

  onFilterShops() {
    this.resetPaginator();
    this._initShops();
  }

  shopLocation(
    ward: string,
    district: string,
    province: string,
    country: string,
  ) {
    return [ward, district, province, country]
      .filter((item) => !!item)
      .join(', ');
  }
}
